import { requestConstantsMaker } from '../helper';

export const GET_COURSE_CATEGORIES_FOR_SELECTION = requestConstantsMaker('GET_COURSE_CATEGORIES_FOR_SELECTION');